import { useNavigate } from "react-router-dom";
import { ArrowRight, Radio } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { RaceDemo } from "@/advisor/demos/RaceDemo";
import { WheelDemo } from "@/advisor/demos/WheelDemo";
import { GiftBoxDemo } from "@/advisor/demos/GiftBoxDemo";
import { Disclaimer } from "@/advisor/Disclaimer";

const pickDemo = (games) => {
  if (games.some((g) => ["race", "viewer_race"].includes(g))) return { slug: "tiktok-race", C: RaceDemo };
  if (games.includes("wheel")) return { slug: "tiktok-wheel", C: WheelDemo };
  return { slug: "tiktok-live-game", C: GiftBoxDemo };
};

export const TiktokLivePanel = ({ onNavigate }) => {
  const { state, toggleSelect } = useAdvisor();
  const nav = useNavigate();
  const { slug, C } = pickDemo(state.tiktokGames);

  const want = () => {
    if (!state.selected.includes(slug)) toggleSelect(slug);
    onNavigate?.();
    nav("/advisor/teklif");
  };

  return (
    <div className="adv-card p-4 sm:p-6 mb-6 border-rose-400/20" data-testid="tiktok-live-panel">
      <div className="flex items-center gap-2 mb-4">
        <span className="flex items-center gap-1.5 bg-rose-500 text-[#F3EEE4] text-xs font-bold px-2 py-1 rounded-md">
          <Radio className="h-3 w-3" /> LIVE
        </span>
        <h3 className="text-lg sm:text-xl font-bold">Canlı Demo</h3>
      </div>
      <p className="text-sm text-[#a9a398] mb-4">Aşağıdakı düymələrlə TikTok hədiyyələrini imitasiya edin və oyunun reaksiyasına baxın.</p>
      <C />
      <div className="mt-4"><Disclaimer /></div>
      <button className="adv-btn-base w-full mt-4 bg-rose-500 hover:bg-rose-400 text-[#F3EEE4]" onClick={want} data-testid="btn-want-tiktok-game">
        Bu oyunu TikTok LIVE üçün istəyirəm <ArrowRight className="h-5 w-5" />
      </button>
    </div>
  );
};
